@use './card-layout-nba-common';

:host {
  @include card-layout-nba-common.wb-card-layout-nba-common;
}

::slotted(.wb-icon) {
  @include card-layout-nba-common.wb-card-layout-nba-icon;
}
